import classNames from 'classnames';

const SearchMagnifierIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const { className = '', ...attributes } = props;
  const classes = classNames('search-icon', className);

  return (
    <svg
      width="34.829"
      height="39.184"
      viewBox="0 0 34.829 39.184"
      className={classes}
      {...attributes}
    >
      <g
        id="Group_111"
        data-name="Group 111"
        transform="translate(-400.072 -242.951)"
      >
        <circle
          id="Ellipse_19"
          data-name="Ellipse 19"
          cx="15"
          cy="15"
          r="15"
          transform="translate(402.072 244.951)"
          fill="none"
          stroke="#fff"
          strokeMiterlimit="10"
          strokeWidth="4"
        />
        <line
          id="Line_8"
          data-name="Line 8"
          x2="6.797"
          y2="6.797"
          transform="translate(425.276 272.509)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="4"
        />
      </g>
    </svg>
  );
};

export default SearchMagnifierIcon;
